<template>
  <div class="lg:mt-36 relative w-full flex justify-left lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 h-96 " style="justify-content:center;">
    <!-- <img class="lg:absolute" src="@/assets/images/ilustraciones/img-sitio-anter_contacto.svg"  height="400" width="320" fill="none" viewBox="0 0 24 24" stroke="currentColor">            -->

<!--  <img class="animate-bounce"  src="@/assets/images/ilustraciones/img-sitio-anter_contacto.svg" height="200" width="260" fill="none" viewBox="0 0 24 24" stroke="currentColor"> -->
  </div>
</template>
